<div [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
  <div
    mat-dialog-title
    [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
    class="modal-header-bg d-flex justify-content-end px-3 pt-1"
  ></div>
  <div
    mat-dialog-content
    [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
  >
    <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
      <div class="overlay-content">
        {{ "choose-account" | translate }}
      </div>
    </div> -->
    <h4 class="font-weight-bold title-text text-start">
      {{ "withdrwal-modal-title" | translate }}
      <img src="assets/img/withdraw.svg" alt="Withdraw" class="withdraw-icon" />
    </h4>
    <p class="text-muted-special subtitle-text text-start">
      {{ "withdrwal-modal-subtitle" | translate }}
    </p>
    <mat-horizontal-stepper [linear]="true" #stepper class="withdraw-stepper-height">
      <!-- <mat-step
        [label]="'select-account' | translate"
        [completed]="selectedAccount"
      >
        <div class="custom-position">
          <user-selection
            [isBindValue]="true"
            (userChanged)="clientSelected($event)"
            (ngModelChange)="onAccountChange($event)"

          ></user-selection>
        </div>
        <div>
          <button class="next-btn-first" mat-button matStepperNext>{{ "Next" | translate }}</button>
        </div>
      </mat-step> -->
      <mat-step
        [editable]="false"
        [label]="'withdrwal-modal-title' | translate"
        [completed]="selectedOption"
      >
        <div class="d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column custom-sm-gap  mt-3">
          <div
            *ngFor="let option of options"
            class="checkbox-container"
            [class.selected-checkBox]="selectedOption === option.id"
            (click)="selectOption(option.id)"
            (mouseover)="hoveredOption = option.id"
            (mouseout)="hoveredOption = null"
          >
            <div class="checkbox-wrapper">
              <div class="label-container">
                <img
                  [src]="
                    'assets/img/' +
                    (selectedOption === option.id || hoveredOption === option.id
                      ? option.icon
                      : option.hoverIcon) +
                    '.png'
                  "
                  alt="Option Icon"
                  class="option-icon"
                />
                <label
                  (click)="$event.stopPropagation()"
                  class="checkBox-label"
                  [for]="option.id"
                >
                  {{ option.label }}
                </label>
              </div>

              <input
                class="mx-2"
                type="checkbox"
                [id]="option.id"
                [checked]="selectedOption === option.id"
                (click)="$event.stopPropagation()"
                (change)="selectOption(option.id)"
              />
            </div>
          </div>
        </div>
        <div class="alert-div alert-div-warning d-flex flex-wrap mt-xl-2  mt-lg-2  mt-md-2  mt-sm-2  mt-4  mb-4">
          <div class="content-w mx-2 d-flex flex-column align-items-start">
            <div class="d-flex">
              <div class="icon-w">
                <img src="assets/img/ring.svg" alt="" />
              </div>
              <span class="yellow-text mx-1 font-600">
                {{ "withdrwal-modal-alert-title" | translate }}
              </span>
            </div>
            <span class="alert-desc-color font-small mx-4 text-start">
              {{ "withdrwal-modal-alert-text" | translate }}
            </span>
          </div>
        </div>
        <div>
          <button class="next-btn" mat-button matStepperNext>
            {{ "Next" | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="'withdrwal-transfer-details' | translate"
        [completed]="selectedOption"
      >
        <form class="mt-3" #withdrawForm="ngForm" (ngSubmit)="submitWithdraw(withdrawForm)">
          <div class="form-row mt-3" id="dark">
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{
                "accounts" | translate
              }}</label>
              <ng-select
                [formControl]="selectedAccountControl"
                (ngModelChange)="onAccountChange($event)"
                [searchable]="false"
                class="custom"
                ngModel
                name="RelationCode"
                [dropdownPosition]="'bottom'"
                required
                [placeholder]="'accounts' | translate"
              >
              <ng-template ng-label-tmp let-item="selectedAccount">
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ selectedAccount.clientNameEn }} — {{ (selectedAccount.accountTypeEn )}}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" class="option-ar">
                          <span>{{ selectedAccount.clientNameAr }}</span> -
                          <span>({{ selectedAccount.accountTypeAr }})</span>
                        </span>
                      </ng-template>
                <ng-option
                  *ngFor="let Acc of accountList"
                  [value]="Acc.relationCode"
                >
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ Acc.clientNameEn }} — {{ Acc.accountTypeEn }}
                        </span>

                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                          <span>{{ Acc.clientNameAr }}</span>
                          <span>{{ Acc.accountTypeAr }}</span>
                        </span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{
                "currency" | translate
              }}</label>
              <ng-select
                [searchable]="false"
                class="custom"
                [(ngModel)]="selectedCurrency"
                (ngModelChange)="onCurrencyChange($event)"
                name="CurrencyId"
                required
                [placeholder]="'currency' | translate"
              >
                <ng-option *ngFor="let curr of currencyList" [value]="curr">
                  {{
                    translate.currentLang == "en"
                      ? curr.CurrencyNameE
                      : curr.CurrencyNameA
                  }}
                </ng-option>
              </ng-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{
                "date" | translate
              }}</label>
              <div>
                <input
                  [min]="today"
                  class="form-control"
                  #date="ngModel"
                  id="date"
                  matInput
                  name="withdrawDate"
                  [(ngModel)]="newWithdraw.Date"
                  [matDatepicker]="picker"
                  required
                  [placeholder]="today"
                  readonly
                />
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="required form-field-title">{{
                "withdraw-amount" | translate
              }}</label>
              <input
                [placeholder]="'withdraw-amount' | translate"
                [(ngModel)]="newWithdraw.Amount"
                #Amount="ngModel"
                name="Amount"
                type="text"
                class="form-control"
                required
                min="1"
                appTwoDigitDecimalNumber
                appInputCommaSepreated
                [ngClass]="
                  translate.currentLang == 'en'
                    ? 'number-input'
                    : 'number-input-ar'
                "
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
              />
              <span
                *ngIf="availableWithdrawBalance != null"
                [ngClass]="{
                  green: availableWithdrawBalance > 0,
                  red: availableWithdrawBalance <= 0
                }"
              >
                {{ "availb-bal-withdraw" | translate }} :
                <strong *ngIf="availableWithdrawBalance % 1 != 0">{{
                  availableWithdrawBalance | number
                }}</strong>
                <strong *ngIf="availableWithdrawBalance % 1 == 0">{{
                  availableWithdrawBalance | number
                }}</strong>
              </span>
              <p *ngIf="availableWithdrawBalance < newWithdraw.Amount" class="red">{{"exceedAvailableBalance" | translate}}</p>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-field-title">{{ "notes" | translate }}</label>
              <textarea
                [placeholder]="'notes' | translate"
                [(ngModel)]="newWithdraw.Note"
                #Note="ngModel"
                name="Note"
                class="form-control notes-textarea"
                rows="2"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
                maxlength="250"
              ></textarea>
            <label style="color: red;" class="char-count-label" *ngIf="newWithdraw.Note?.length == 250">
              Max Limit is 250 characters
            </label>          
            </div>
            <div *ngIf="newWithdraw.ActionType == 2" class="col-md-12">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="required form-field-title">{{
                    "deposit-bank" | translate
                  }}</label>
                  <ng-select
                    [(ngModel)]="selectedBank"
                    [clearable]="false"
                    name="depositBank"
                    #depositBank="ngModel"
                    class="custom"
                    ngModel
                    (change)="GetBranches($event.BankID)"
                    [required]="newWithdraw.ActionType == 2"
                  >
                    <ng-option *ngFor="let bank of banksList" [value]="bank">
                      {{
                        translate.currentLang == "en"
                          ? bank.BankNameE
                          : bank.BankNameA
                      }}
                    </ng-option>
                  </ng-select>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="required form-field-title">{{
                    "bank-branch" | translate
                  }}</label>
                  <ng-select
                    [(ngModel)]="selectedBranch"
                    [clearable]="false"
                    name="bankBranch"
                    #bankBranch="ngModel"
                    class="custom"
                    ngModel
                    [required]="newWithdraw.ActionType == 2"
                  >
                    <ng-option *ngFor="let branch of branches" [value]="branch">
                      {{
                        translate.currentLang == "en"
                          ? branch.BankNameE
                          : branch.BankNameA
                      }}
                    </ng-option>
                  </ng-select>
                </div>
                    <div class="col-md-12 mb-3">
                      <label class="required form-field-title">
                        {{ "iban-or-account-number" | translate }}
                      </label>

                      <input
                        [(ngModel)]="newWithdraw.ibanOrAccount"
                        name="ibanOrAccount"
                        #ibanOrAccount="ngModel"
                        type="text"
                        class="form-control"
                        placeholder="Enter IBAN or Account Number"
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        required
                        (blur)="detectIbanOrAccount()"
                      />

                      <!-- Validation messages -->
                      <div *ngIf="ibanOrAccount.invalid && ibanOrAccount.touched" class="text-danger small">
                        {{ "invalid-value" | translate }}
                      </div>
                    </div>
              </div>
            </div>
          </div>
          <div class="row px-2 mt-3" style="justify-content: end">
            <button
            mat-button
              (click)="submitWithdraw(withdrawForm)"
              class="next-btn-first text-light"
              type="submit"
              [disabled]="
                withdrawForm.invalid ||
                newWithdraw.Amount > availableWithdrawBalance ||
                isSubmitting
              "
            >
              <span
                *ngIf="isSubmitting"
                class="spinner-border spinner-border-sm"
              ></span>
              {{ "send" | translate }}
            </button>
          </div>
          <span class="info-warning">{{ "withdraw-note" | translate }}</span>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
